import React, { useState } from 'react';
import { Paper, TableContainer, Table, TableHead, TableRow, TableBody, TablePagination, Typography } from '@mui/material';
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

import { styled } from '@mui/material/styles';

const data = [
  {
    slNo: '1.',
    caseNo: 'Civil Appeal (D) no. 14669/ 2019',
    title: 'State of H.P vs. Yogendra Mohan Sengupta.',
    nature: 'NGT judgment dated 16.11.2017 challenged being extra-jurisdictional and scope of NGT.',
    nextDate: 'Not given',
  },
  {
    slNo: '2.',
    caseNo: 'Civil Appeal Diary no. 44451/ 2018.',
    title: 'Pushpinder Singh Chopra versus SPOKE and others.',
    nature: 'Construction of HPTDC Hotel at Kasauli challenged, which was approved by NGT vide its order dated 05.10.2018.',
    nextDate: 'Not given',
  },
  {
    slNo: '3.',
    caseNo: 'Civil Appeal no. 4526 of 2019',
    title: 'Kasauli Hoteliers Resident Welfare Associations versus SPOKE',
    nature: 'NGT judgment dated 05.10.2018 challenged being extra-jurisdictional and the scope of NGT.',
    nextDate: 'Not given',
  },
  {
    slNo: '4.',
    caseNo: 'Civil Appeal no. 10377 of 2017',
    title: 'Hotel Kasauli Inn. &anr. versus SPOKE',
    nature: 'NGT judgment dated 05.10.2018 challenged being extra-jurisdictional and the scope of NGT.',
    nextDate: 'Not given',
  },
  {
    slNo: '5.',
    caseNo: 'Civil Appeal Diary no. 14669 of 2019.',
    title: 'State of Himachal versus SPOKE & others.',
    nature: 'NGT judgment dated 05.10.2018 challenged being extra-jurisdictional and the scope of NGT.',
    nextDate: 'Not given',
  },
  {
    slNo: '6.',
    caseNo: 'Civil Appeal no.2823/ 2018',
    title: 'Ramesh Chand versus State of Uttar Pradesh & others',
    nature: 'NGT order dated 8.12.2017 challenged',
    nextDate: 'Not given',
  },
  {
    slNo: '7.',
    caseNo: 'Civil Appeal no. 829 of 2019',
    title: 'M/S Citrus Manali Resorts Pvt. Ltd. versus Ramesh Chand and others',
    nature: 'NGT order dated 8.12.2017 challenged',
    nextDate: 'Not given',
  },
  {
    slNo: '8.',
    caseNo: 'SLP- (C) no. 2865-66/ 2014',
    title: 'HPCA versus State of H.P & ors.',
    nature: 'Issue of construction of HPCA ground and diversion of Forest land etc.',
    nextDate: 'Not given',
  },
  {
    slNo: '',
    caseNo: '',
    title: '',
    nature: 'NATIONAL GREEN TRIBUNAL.',
    nextDate: '',
  },
  {
    slNo: '9.',
    caseNo: 'O.A. no. 104/ 2018',
    title: 'Shiv Pal Bhagat vs. State of H.P',
    nature: 'Illegal setting up of 2 septic tanks and one electric transformer in complete violation of Article 21 of the Constitution of India.',
    nextDate: 'Not given',
  },
  {
    slNo: '10.',
    caseNo: 'O.A No. 606/2018',
    title: 'Solid Waste Management Rules 2016 &amp; other environmental issues.',
    nature: 'Preparing of a State Policy and Management strategies',
    nextDate: 'Not Given',
  },
  {
    slNo: "11",
    caseNo: "CWP no. 4869/ 2021",
    title: "GurucharanKaur vs. State",
    nature: "Disconnection of electricity on account of unauthorized construction in Manali.",
    nextDate: "Not given"
  },
  {
    slNo: "12",
    caseNo: "CWP no. 2243/ 2021",
    title: "M/S Himachal Conductors Ltd. vs. State of H.P",
    nature: "Issue of permission under Section 118 of HPT&amp;LRA, 1972 and apartments.",
    nextDate: "Not given"
  },
  {
    slNo: "13",
    caseNo: "CWP no. 4439/ 2021",
    title: "Tulsia vs. State of H.P",
    nature: "Unauthorized construction of building in Solan.",
    nextDate: "Not given"
  },
  {
    slNo: "14",
    caseNo: "CWPIL no. 13/ 2021",
    title: "Kusum Bali vs. State of H.P",
    nature: "To regulate TCP Act in Kummarhatti-Dagshai area.",
    nextDate: "Not given"
  },
  {
    slNo: "15",
    caseNo: "CWP no. 873/ 2021",
    title: "Suresh Kumar vs. State of H.P",
    nature: "Service matter.",
    nextDate: "Not given"
  },
  {
    slNo: "16",
    caseNo: "CWP no. 3832/ 2021",
    title: "Diamond Traexim vs. State of H.P",
    nature: "Construction of M/S Nirvana Woods project and its planning permission.",
    nextDate: "Not given"
  },
  {
    slNo: "17",
    caseNo: "COPC no. 14/ 2021",
    title: "M/S Himland Housing vs. State of H.P",
    nature: "Contempt of Court proceedings/ order\n\nSection 118 permission lapse.",
    nextDate: "Not given"
  },
  {
    slNo: "18",
    caseNo: "CWPIL no. 20/ 2021",
    title: "UdayPanwar vs. State of H.P",
    nature: "Unauthorized construction of building near Kasumpti.",
    nextDate: "Not given"
  },
  {
    slNo: "19",
    caseNo: "CWP no. 2470/ 2021",
    title: "Shagun Sharma vs. State of H.P",
    nature: "Service matter/ Transfer of P.O on complaint",
    nextDate: "Not given"
  },
  {
    slNo: "20",
    caseNo: "CWP no. 692/ 2021",
    title: "Ravi Kumar versus State of H.P &amp; ors",
    nature: "Construction of petrol pump challenged",
    nextDate: "Not given"
  },
  {    slNo: "21.",    caseNo: "CWP no. 5038/ 2021",    title: "Mohinder Singh versus State of H.P & ors.",    nature: "Allotment of shop MC Dharamshala.",    nextDate: "Not given"  },  {    slNo: "22.",    caseNo: "CRMMO no. 204/ 2021",    title: "Savita Sharma versus State of H.P & ors.",    nature: "Quashing of FIR. Forgery of documents, Solan. Quashing of FIR. Forgery of documents, Solan.",    nextDate: "Not given"  },  {    slNo: "23.",    caseNo: "RSA no. 15/ 2021",    title: "Govind versus Santosh Kumar/State of H.P & ors.",    nature: "Civil litigation qua suit land/ substantial question of law.",    nextDate: "Not given"  },  {    slNo: "24.",    caseNo: "CWP no. 3833/ 2021",    title: "SumitKhanna versus UOI & ors.",    nature: "Regarding order of HP RERA on real estate project.",    nextDate: "Not given"  },  {    slNo: "25.",    caseNo: "CWP no. 5982/ 2021",    title: "PuneetKanwar versus State of H.P & ors.",    nature: "Job on compassionate grounds",    nextDate: "Not given"  },  {    slNo: "26.",    caseNo: "LPA no. 89/ 2021",    title: "Ruma Devi versus State of H.P & ors.",    nature: "Service benefits of deceased employee including GPF etc.",    nextDate: "Not given"  },  {    slNo: "27.",    caseNo: "Execution petition no. 13/ 2021",    title: "MrityunjayTripathiversus State of H.P & ors.",    nature: "Execution of NGT order passed in the judgment dated 16.11.2017.",    nextDate: "Not given"  },  {    slNo: "28.",    caseNo: "CMPMO 84/ 2020",    title: "Rani Kukreja vs. State of H.P",    nature: "Regarding dismissal of Civil Suits having same cause of action in lower Courts.",    nextDate: "Not given"  },  {    slNo: "29.",    caseNo: "CWP no. 442/ 2020",    title: "Jagdish Chand versus State of HP",    nature: "Planning permission and approvals with Section 16-C.",    nextDate: "Not given"  },  {    slNo: "30.",    caseNo: "CWP no. 3715/ 2020",    title: "Neelam Boris versus State of HP",    nature: "Installation of mobile towers at buildings in Shimla near Aukland House School.",    nextDate: "Not given"  },
  {
    slNo: "31.",
    caseNo: "CWP no. 628/ 2020",
    title: "BhagwanDasi versus State of HP (Connected matter with CWPIL no. 15/ 14)",
    nature: "Composition of deviations of building- Shimla- Kalka NH",
    nextDate: "Not given"
  },
  {
    slNo: "32.",
    caseNo: "CWP no. 1503/ 2020",
    title: "RajanBadhan versus State of HP",
    nature: "Planning permission and approval case.",
    nextDate: "Not given"
  },
  {
    slNo: "33.",
    caseNo: "CWP no. 2825 2020",
    title: "Ajay Sharma versus State of HP",
    nature: "Violation of Section 16-C, SADA Una.",
    nextDate: "Not given"
  },
  {
    slNo: "34.",
    caseNo: "CWP no. 1893/ 2020",
    title: "Naresh Kumar versus State of HP",
    nature: "Planning permission and approval case.",
    nextDate: "Not given"
  },
  {
    slNo: "35.",
    caseNo: "CWPOA no. 5761/ 2020",
    title: "Virender Kumar vs. State of H.P",
    nature: "Service matter\nSADA employees claiming pay scale and service benefits",
    nextDate: "Not given"
  },
  {
    slNo: "36.",
    caseNo: "CWPOA no. 4929/ 2020",
    title: "Ashok Kumar vs. State of H.P",
    nature: "Service matter.\n\nSADA employees claiming pay scale and service benefits.",
    nextDate: "Not given"
  },
  {
    slNo: "37.",
    caseNo: "CWPOA no. 4923/ 2020",
    title: "Arun Kumar vs. State of H.P",
    nature: "Service matter.\n\nSADA employees claiming pay scale and service benefits.",
    nextDate: "Not given"
  },
  {
    slNo: "38.",
    caseNo: "CWPOA no. 4921/ 2020",
    title: "Rajeev Sharma vs. State of H.P",
    nature: "Service matter.\n\nSADA employees claiming pay scale and service benefits.",
    nextDate: "Not given"
  },
  {
    slNo: "39.",
    caseNo: "CWP no. 3739/ 2020",
    title: "Mahesh Dutt Sharma versus State of HP",
    nature: "Regarding unauthorized construction in Rampur.",
    nextDate: "Not given"
  },
  {
    slNo: "40.",
    caseNo: "CWP no. 935/ 2020",
    title: "Rajni Devi versus State of HP",
    nature: "Case of planning permission and approvals, MC Dharamshala.",
    nextDate: "Not given"
  },
  {
    "slNo": "41.",
    "caseNo": "CWP no. 935/ 2020",
    "title": "Rajni Devi versus State of HP",
    "nature": "Case of planning permission and approvals, MC Dharamshala.",
    "nextDate": "Not given"
    },
    {
    "slNo": "42.",
    "caseNo": "CWP no. 6029/ 2020",
    "title": "SYSCO versus State of H.P & ors.",
    "nature": "Construction of petrol pump challenged",
    "nextDate": "Not given"
    },
    {
    "slNo": "43.",
    "caseNo": "CWP no. 4325/ 2020",
    "title": "Bemloi Development & Infrastructure Pvt. Ltd. versus State of H.P & ors.",
    "nature": "Planning permission case for apartments, Shimla",
    "nextDate": "Not given"
    },
    {
    "slNo": "44.",
    "caseNo": "CWP no. 1447/ 2020",
    "title": "JaneshMahajan versus State of H.P & ors.",
    "nature": "Planning permission case, Dalhousie, Chamba",
    "nextDate": "Not given"
    },
    {
    "slNo": "45.",
    "caseNo": "CWP no. 1462/ 2019",
    "title": "Satish Kumar versus State of HP (Connected matter with CWPIL no. 15/ 14)",
    "nature": "Composition of deviations of building- Shimla- Kalka NH.",
    "nextDate": "Not given"
    },
    {
    "slNo": "46.",
    "caseNo": "CWP no. 2077/ 2019",
    "title": "Madhusoodan versus State of H.P & ors.",
    "nature": "Regarding unauthorized construction in MC Dharamshala.",
    "nextDate": "Not given"
    },
    {
    "slNo": "47.",
    "caseNo": "CWP no. 2774/ 2019",
    "title": "AmanGuleria versus State of H.P & ors.",
    "nature": "Regarding unauthorized construction in MC Dharamshala.",
    "nextDate": "Not given"
    },
    {
    "slNo": "48.",
    "caseNo": "CWP no. 4389/ 2019",
    "title": "BaldevAtri versus State of H.P & ors.",
    "nature": "Regarding the construction of HP Secretariat employee association at AadityaVihar, Shimla",
    "nextDate": "Not given"
    },
    {
    "slNo": "49.",
    "caseNo": "CWP no. 1716/ 2019",
    "title": "Prithvi Chand versus State of H.P & ors.",
    "nature": "Service matter. Regularization of services and benefits.",
    "nextDate": "Not given"
    },
    {
    "slNo": "50.",
    "caseNo": "CWP no. 2086/ 2019",
    "title": "State of HP versus Ramesh Chand & ors.",
    "nature": "NGT order dated 29.07.2019 challenged being without jurisdiction",
    "nextDate": "Not given"
    },
    {
      slNo: "51.",
      caseNo: "CWP no. 2874/ 2019",
      title: "Mehar Chand versus State of H.P & ors.",
      nature: "Service matter. Regularization of services and benefits.",
      nextDate: "Not given"
      },
      {
      slNo: "52.",
      caseNo: "CWPIL no. 12/ 2019",
      title: "Court on its on motion versus State of H.P & ors.",
      nature: "Persons with Disabilities to be provided adequate toilets, barrier free access etc",
      nextDate: "Not given"
      },
      {
      slNo: "53.",
      caseNo: "CWP no. 2607/ 2019",
      title: "Dev Krishnan versus State of H.P & ors.",
      nature: "Matter pertaining to SADA, Kinnaur.",
      nextDate: "Not given"
      },
      {
      slNo: "54.",
      caseNo: "CWP no. 1465/ 2019",
      title: "Srijan Sharma versus State of H.P & ors.",
      nature: "Permission to carry out construction in green area of Shimla Planning area.",
      nextDate: "Not given"
      },
      {
      slNo: "55.",
      caseNo: "CWP no. 604/ 2019",
      title: "Udho Builders Pvt. Ltd. versus State of H.P & ors.",
      nature: "Case of Planning permission for apartments, Solan.",
      nextDate: "Not given"
      },
      {
      slNo: "56.",
      caseNo: "CWP no. 200/ 2019",
      title: "Devinder Singh versus State of H.P & ors.",
      nature: "Planning permission and approvals MC Dharamshala.",
      nextDate: "Not given"
      },
      {
      slNo: "57.",
      caseNo: "CWP no. 1140/ 2019",
      title: "Sandeep Kumar versus State of H.P & ors.",
      nature: "Composition of deviations/ unauthorized construction in a building, Manali.",
      nextDate: "Not given"
      },
      {
      slNo: "58.",
      caseNo: "CWP no. 3120/ 2019",
      title: "Rakesh Kumar versus State of Uttar Pradesh & ors.",
      nature: "Regarding planning permission, Bilaspur",
      nextDate: "Not given"
      },
      {
      slNo: "59.",
      caseNo: "CWP no. 2610/ 2019",
      title: "PoonamGehlot versus State of Uttar Pradesh & ors.",
      nature: "Regarding challenging of Rule 35 of the HP TCP Act being ultra vires.",
      nextDate: "Not given"
      },
      {
      slNo: "60.",
      caseNo: "CWP no. 925/ 2019",
      title: "Satpal versus State of H.P & ors.",
      nature: "Planning permission and approvals, SADA Una",
      nextDate: "Not given"
      },
      {
        "slNo": "61.",
        "caseNo": "CWP no. 1208/ 2018",
        "title": "Mulkh Raj versus State of H.P &amp; ors.",
        "nature": "Planning permission and approvals, Dalhousie.",
        "nextDate": "Not given"
      },
      {
        "slNo": "62.",
        "caseNo": "CWP no. 1716/ 2018",
        "title": "HP Secretariat Employees Cooperative Housing Society (regd.) versus State of H.P &amp; ors.",
        "nature": "Planning permission and approvals.",
        "nextDate": "Not given"
      },
      {
        "slNo": "63.",
        "caseNo": "Review petition no. 78/ 2018",
        "title": "State of H.P versus Hitanshu Jistu.\n(Retention policy case.)",
        "nature": "Review for saving Section 30-B of HP TCP (Amendment) Act, 2016 quashed by High Court on 22.12.2017.",
        "nextDate": "Not given"
      },
      {
        "slNo": "64.",
        "caseNo": "Review petition no. 79/ 2018",
        "title": "State of H.P versus RaghavGoel.\n(Retention policy case.)",
        "nature": "Review for saving Section 30-B of HP TCP (Amendment) Act, 2016 quashed by High Court on 22.12.2017.",
        "nextDate": "Not given"
      },
      {
        "slNo": "65.",
        "caseNo": "Review petition no. 80/ 2018",
        "title": "State of H.P versus AbhimanyuRathor.\n(Retention policy case.)",
        "nature": "Review for saving Section 30-B of HP TCP (Amendment) Act, 2016 quashed by High Court on 22.12.2017.",
        "nextDate": "Not given"
      },
      {
        "slNo": "66.",
        "caseNo": "CWP no. 825/ 2018",
        "title": "KundanLalVerma versus State of Uttar Pradesh &amp; ors.",
        "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
        "nextDate": "Not given"
      },
      {
        "slNo": "67.",
        "caseNo": "CWP no. 826/2018",
        "title": "Harvinder Singh versus State of Uttar Pradesh &amp; ors.",
        "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
        "nextDate": "Not given"
      },
      {
        "slNo": "68.",
        "caseNo": "CWP no. 828/ 2018",
        "title": "AkshaySood versus State of Uttar Pradesh &amp; ors.",
        "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
        "nextDate": "Not given"
      },
      {
        "slNo": "69.",
        "caseNo": "CWP no. 829/ 2018",
        "title": "Samni Devi versus State of Uttar Pradesh",
        "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
        "nextDate": "Not given"
      },
      {
        "slNo": "70.",
        "caseNo": "CWP no. 827/ 2018",
        "title": "NeerajGhunta versus State of Uttar Pradesh  &amp; ors.",
        "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
        "nextDate": "Not given"
      },
      {
        "slNo": "71.",
        "caseNo": "CWP no. 831/ 2018",
        "title": "Baldev Singh versus State of Uttar Pradesh &amp; ors.",
        "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
        "nextDate": "Not given"
      },
      {
        "slNo": "72.",
        "caseNo": "CWP no. 832/ 2018",
        "title": "PremThanta versus State of Uttar Pradesh &amp; ors.",
        "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
        "nextDate": "Not given"
    },
    {
        "slNo": "73.",
        "caseNo": "CWP no. 833/ 2018",
        "title": "Lata versus State of Uttar Pradesh &amp; ors.",
        "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
        "nextDate": "Not given"
    },
    {
        "slNo": "74.",
        "caseNo": "CWP no. 834/ 2018",
        "title": "Inder Singh versus State of Uttar Pradesh &amp; ors.",
        "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
        "nextDate": "Not given"
    },
    {
        "slNo": "75.",
        "caseNo": "CWP no. 1648/ 2018 a/w CWP no. 63/ 2019",
        "title": "Yashpal Singh Sandhu versus State of Uttar Pradesh &amp; ors.",
        "nature": "Regarding illegal and unauthorized construction of building and encroachment, MC Dharamshala.",
        "nextDate": "Not given"
    },
    {
        "slNo": "76.",
        "caseNo": "CWP no. 121/ 2017",
        "title": "Savitri Devi versus State of Uttar Pradesh &amp; ors.",
        "nature": "Planning permission and approvals, Chamba",
        "nextDate": "Not given"
    },
    {
        "slNo": "77.",
        "caseNo": "RSA no. 264/ 2017",
        "title": "Seema Devi versus State of Uttar Pradesh &amp; ors.",
        "nature": "Substantial question of law.",
        "nextDate": "Not given"
    },
    {
        "slNo": "78.",
        "caseNo": "CWP no. 383 2017",
        "title": "Vivek Enterprises versus State of Uttar Pradesh &amp; ors.",
        "nature": "Planning permission and approval of Apartments.",
        "nextDate": "Not given"
    },
    {
        "slNo": "79.",
        "caseNo": "CWP no. 383 2017",
        "title": "Sanya Enterprises versus State of Uttar Pradesh &amp; ors.",
        "nature": "Planning permission and approval of Apartments.",
        "nextDate": "Not given"
    },
    {
        "slNo": "80.",
        "caseNo": "RSA no. 214/ 2017",
        "title": "MeenaVerma versus State of Uttar Pradesh &amp; ors",
        "nature": "Substantial question of law.",
        "nextDate": "Not given"
    },
    {
      "slNo": "81.",
      "caseNo": "RSA no. 121/ 2017",
      "title": "Samriti Jain versus State of Uttar Pradesh &amp; ors.",
      "nature": "Substantial question of law./ ATP Parwanoo",
      "nextDate": "Not given."
  },
  {
      "slNo": "82.",
      "caseNo": "CWP no. 265/2016",
      "title": "Sushma Devi versus State of Uttar Pradesh &amp; ors",
      "nature": "Planning permission and approval, SADA Chintpurni",
      "nextDate": "Not given."
  },
  {
      "slNo": "83.",
      "caseNo": "CWP no. 944/2016",
      "title": "Ramesh Chand versus State of Uttar Pradesh &amp; ors.",
      "nature": "Unauthorized constructions and illegal encroachment cases in Solan MC area.",
      "nextDate": "Not given."
  },
  {
      "slNo": "84.",
      "caseNo": "CWP no. 1998/2016 a/w CWPIL no. 26/ 16",
      "title": "DevBhoomi versus State of Uttar Pradesh &amp; ors",
      "nature": "Construction of apartments in Solan.",
      "nextDate": "Not given."
  },
  {
      "slNo": "85.",
      "caseNo": "RSA no. 289/ 2016",
      "title": "HiraLal versus Ram Krishan/ State of Uttar Pradesh &amp; ors.",
      "nature": "Substantial question of law",
      "nextDate": "Not given."
  },
  {
      "slNo": "86.",
      "caseNo": "CWP no. 8/2016",
      "title": "SL Anand versus State of Uttar Pradesh &amp; ors.",
      "nature": "Planning permission and approvals.",
      "nextDate": "Not given."
  },
  {
      "slNo": "87.",
      "caseNo": "CWP no. 990/2016",
      "title": "Shivani Sharma versus State of Uttar Pradesh &amp; ors.",
      "nature": "Installation of communication towers.",
      "nextDate": "Not given."
  },
  {
      "slNo": "88.",
      "caseNo": "CWP no. 1501/2016",
      "title": "HimlandHousing&nbsp; versus State of Uttar Pradesh &amp; ors.",
      "nature": "Approvals of planning permission and Section 118 HPT&amp;LRA, 1972",
      "nextDate": "Not given."
  },
  {
      "slNo": "89.",
      "caseNo": "CWP no. 4149/2015",
      "title": "RoshanLal versus State of Uttar Pradesh &amp; ors.",
      "nature": "Unauthorized construction of building and composition of deviations, Rampur.",
      "nextDate": "Not given."
  },
  {
      "slNo": "90.",
      "caseNo": "CWP no. 2150/2015",
      "title": "Madanjit Singh versus State of Uttar Pradesh &amp; ors.",
      "nature": "Planning permission and approvals Kasauli Planning area.",
      "nextDate": "Not given."
  },
  {
    "slNo": "91.",
    "caseNo": "CWPIL no. 14/2014",
    "title": "Court on its own motion versus State of Uttar Pradesh &amp; ors.",
    "nature": "Regarding unauthorized constructions across Shimla Kalka National Highway",
    "nextDate": "Not given."
},
{
    "slNo": "92.",
    "caseNo": "LPA no. 121/ 2012",
    "title": "Vijay Kumar Aggarwal versus State of Uttar Pradesh &amp; ors.",
    "nature": "Regarding unauthorized construction and approvals of planning permission, Hotel Gulmarg.",
    "nextDate": "Not given."
},
{
    "slNo": "93.",
    "caseNo": "CWP no. 11636/ 2011",
    "title": "Purujit Singh versus State of Uttar Pradesh &amp; ors.",
    "nature": "Construction of tourism village, Naldhera and Rule 16 of the HP TCP Rules.",
    "nextDate": "Not given."
},
{
    "slNo": "94.",
    "caseNo": "CWP no. 9222/ 2011",
    "title": "Jeet Ram versus State of Uttar Pradesh &amp; ors",
    "nature": "Construction of building under retention policy and to supply list of all unauthorized constructions in Shimla.",
    "nextDate": "Not given."
},
{
    "slNo": "95.",
    "caseNo": "RSA no. 104/ 2010",
    "title": "Vijay Kumar versus State of Uttar Pradesh &amp; ors.",
    "nature": "Substantial question of law to quash the judgment dated 26.11.2009 passed by District Judge, Shimla",
    "nextDate": "Not given."
},
{
    "slNo": "96.",
    "caseNo": "RSA no. 615/ 2009",
    "title": "Tula Ram versus Onkar Chand/ State of Uttar Pradesh &amp; ors.",
    "nature": "Substantial question of law to quash the judgment dated 30.09.2009 passed by District Judge, Shimla",
    "nextDate": "Not given"
},
{
    "slNo": "97.",
    "caseNo": "RFA no. 235/ 2005 a/w 243/ 2005",
    "title": "Nirmal Singh vs. Tibetans Children Village Society.",
    "nature": "Substantial question of law",
    "nextDate": "Not given"
},
{
    "slNo": "98.",
    "caseNo": "CWP no. 511/ 2004",
    "title": "Smt. Usha Devi versus State of Uttar Pradesh &amp; ors.",
    "nature": "Case of planning permission and inter se dispute qua property between private parties.",
    "nextDate": "Not given"
},
{
    "slNo": "99.",
    "caseNo": "Civil Suit no. 45/ 2002",
    "title": "BharamVasu versus State of Uttar Pradesh &amp; ors.",
    "nature": "Civil Suit for recovery between private parties.",
    "nextDate": "Not given"
},
{
    "slNo": "100.",
    "caseNo": "CWP No.&nbsp;&nbsp; /2021-",
    "title": "Devender Singh V/s State of H.P.",
    "nature": "Change of Land use from Residence to Guest House/Hotel",
    "nextDate": "Not given"
},
{
    "slNo": "101.",
    "caseNo": "CWP No. 6584 / 2021",
    "title": "Gaurav Kapret V/s State of HP",
    "nature": "Setting up of Retail outlet dealership at a location between Auckland Tunnel to Dhalli Bye-pass Chowk.",
    "nextDate": "Not given"
},
{
    "slNo": "102.",
    "caseNo": "CWP No. 7496/2021",
    "title": "Shamit Sood V/s State of H.P",
    "nature": "Planning Permission case\nPetitioner is aggrieved by the sanctioning of the map approved by Respondent No. 3 to 5 in favor of Respondent No. 6 &amp; 7 without adopting the proper procedures at the time of sanctioning of same. (Area falls within the ambit of jurisdiction of M.C. Theog and the powers of Director TCP stand delegated to M.C. Theog vide Notification dated 06.06.2016).",
    "nextDate": "Not given"
},
{
    "slNo": "103.",
    "caseNo": "CWP No. 7876/2021",
    "title": "Tarun Bakshi V/s State of H.P.",
    "nature": "Petitioner has submitted his case regarding planning permission of their building plans submitted on 03.08.2107 much prior to the passing of the judgement dated 16.11.2017 by the Ld.NGT in case titled as Yogender Mohansen Gupta. The petitioner prays that his case may be considered as per the law/rules and as per the clarifications opinion rendered by the State Govt. of H.P. and Law Deptt. of the State govt. on 01.02.2018, 29.10.2018, 06.12.216 and 24.1.2019.",
    "nextDate": "22.03.2022"
},
{
    "slNo": "104.",
    "caseNo": "CWP No.&nbsp;&nbsp;&nbsp;&nbsp; /2021",
    "title": "Desh Raj V/s State of H.P.",
    "nature": "Service matter",
    "nextDate": "-------"
},
{
    "slNo": "105.",
    "caseNo": "Caveat&nbsp;&nbsp;&nbsp;&nbsp; 2021",
    "title": "Vidya Sharma",
    "nature": "Service matter",
    "nextDate": "-------"
},
{
  "slNo": "106.",
  "caseNo": "CWP No.&nbsp;&nbsp;&nbsp;&nbsp; 2021",
  "title": "M/s Himland Real Estate V/s State of H.P.",
  "nature": "Case regarding provisions of Section 118 of H.P. Tenancy&nbsp; Land and Reforms Act.",
  "nextDate": "-------"
},
{
  "slNo": "107.",
  "caseNo": "CWP No. 7285/2021",
  "title": "Anita Devi V/s State",
  "nature": "Service Matter\nCase regarding appointment of Jr. Engineer in TCP Deptt.",
  "nextDate": "-------"
},
{
  "slNo": "108",
  "caseNo": "CWP No.&nbsp;&nbsp; /2021",
  "title": "Balbir Singh",
  "nature": "Regarding illegal encroachment done by Respondent No. 6 to 9 on the land of Respondent No. 3 and on petitioner's own land",
  "nextDate": "-------"
},
{
  "slNo": "109.",
  "caseNo": "CWP No.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; /2021",
  "title": "Nahan Gaurav Vikas Sanstha (Regd) V/s State of H.P. &amp; otrs",
  "nature": "The petitioner has filed this petition with an intention to save the environment and forest of the Nahan town.",
  "nextDate": "-------"
},
{
  "slNo": "110.",
  "caseNo": "CWP No. 627/2022",
  "title": "Meena Thakur V/s State",
  "nature": "Planning permission case",
  "nextDate": "-------"
},
{
  "slNo": "111.",
  "caseNo": "CWP No. 547/2022",
  "title": "Sunil Malhotra V/s State of H.P.",
  "nature": "Unauthorized construction Case",
  "nextDate": "-------"
},
{
  "slNo": "112.",
  "caseNo": "Civil Suit",
  "title": "Rajkumar vs. Hem Chand.",
  "nature": "Civil Suit for a declaration under Section 34 of the Specific Relief Act.",
  "nextDate": "Not Given."
},
{
  "slNo": "113.",
  "caseNo": "Civil Suit no. 26/ 2020",
  "title": "Sita Ram Verma vs. State of H.P",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
},
{
  "slNo": "114.",
  "caseNo": "Civil Suit",
  "title": "Ramesh Chauhan vs. State of H.",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
},
{
  "slNo": "115.",
  "caseNo": "Civil Suit",
  "title": "Gulab Singh vs. Tara Dutt",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "18.10.2021"
},
{
  "slNo": "116.",
  "caseNo": "Civil Suit no. 45/ 2019",
  "title": "M/S PrabhaBhagra vs. State of H.P",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "27.10.2021"
},
{
  "slNo": "117.",
  "caseNo": "Civil Suit",
  "title": "Subash Chand vs. Surinder Thakur.",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
},
{
  "slNo": "118.",
  "caseNo": "Civil Suit",
  "title": "Ashutosh Chauhan vs. YontanNegi",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
},
{
  "slNo": "119.",
  "caseNo": "Civil Suit",
  "title": "Kanta vs. kaushalya",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
},
{
  "slNo": "120.",
  "caseNo": "Civil Suit",
  "title": "Bhupinder Singh vs. SADA.",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "30.10.2021"
},
{
  "slNo": "121.",
  "caseNo": "Civil Suit",
  "title": "Dinesh Sharma vs. State of H.P",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
},
{
  "slNo": "122.",
  "caseNo": "Civil Suit",
  "title": "Manoharlal vs. State of H.P.",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
},
{
  "slNo": "123.",
  "caseNo": "Civil Suit",
  "title": "Budhmaya vs. State of H.P.",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
},
{
  "slNo": "124.",
  "caseNo": "Civil Suit",
  "title": "Asha Devi vs. ChetnaChauhan.",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
}
      
]
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const CourtOrders = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const headerData = [
    { label: 'SL. No' },
    { label: 'Case No' },
    { label: 'Title of the Case' },
    { label: 'Nature of the Case' },
    { label: 'Next Date' }
  ];
  return (
    <Paper sx={{ overflow: "hidden", marginY: 2 }}>
    <Typography variant='h6' style={{marginLeft: '20px', textDecoration: 'underLine'}}>
      Court Orders
    </Typography>
    <Typography variant='h5' style={{marginLeft: '20px',marginTop: '20px'}}>
      Supreme Court Of India
    </Typography>
    <Typography variant='h6' style={{marginLeft: '20px', marginTop: '10px'}}>
      Not Given
    </Typography>
    <TableContainer>
      <Table aria-label="simple table" style={{width: '95%', margin: '10px 20px'}}>
        <TableHead>
          <TableRow>
            {headerData.map((item) => (
              <StyledTableCell key={item.label} style={{border: '1px solid #ffff'}}>
                {item.label}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody style={{ backgroundColor: '#fbfaff' }}>
          {data
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => (
              <StyledTableRow key={row.slNo}>
                <StyledTableCell>{index + 1 + page * rowsPerPage}</StyledTableCell>
                <StyledTableCell>{row.caseNo}</StyledTableCell>
                <StyledTableCell>{row.title}</StyledTableCell>
                <StyledTableCell>{row.nature}</StyledTableCell>
                <StyledTableCell>{row.nextDate}</StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
    <TablePagination
      rowsPerPageOptions={[10, 25, 50, 75, 100]}
      component="div"
      count={data.length}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  </Paper>
  );
};

export default CourtOrders;

